import { render, staticRenderFns } from "./BuyDirectGroup.vue?vue&type=template&id=6369ae90&scoped=true&"
import script from "./BuyDirectGroup.vue?vue&type=script&lang=js&"
export * from "./BuyDirectGroup.vue?vue&type=script&lang=js&"
import style0 from "./BuyDirectGroup.vue?vue&type=style&index=0&id=6369ae90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369ae90",
  null
  
)

export default component.exports